import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CheckoutComponent} from './checkout.component';
import {AddCardComponent} from './add-card/add-card.component';
import {PaymentsViewComponent} from './payments-view/payments-view.component';
import {PaymentItemComponent} from './payment-item/payment-item.component';
import {MaterialModule} from '../material.module';
import {CommonModule} from '@angular/common';
import {VerifyCheckoutComponent} from './verify-checkout/verify-checkout.component';
import {PublicModule} from '../public/public.module';

@NgModule({
    declarations: [
        CheckoutComponent,
        AddCardComponent,
        PaymentsViewComponent,
        PaymentItemComponent,
        VerifyCheckoutComponent,
    ],
    imports: [
        CommonModule,
        MaterialModule,
        PublicModule,
    ],
    exports: [
        CheckoutComponent,
        AddCardComponent,
        PaymentsViewComponent,
        PaymentItemComponent,
        VerifyCheckoutComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CheckoutModule {
}
